import { render, staticRenderFns } from "./widget-enem-card.server.vue?vue&type=template&id=654b77d9&scoped=true"
var script = {}
import style0 from "./widget-enem-card.server.vue?vue&type=style&index=0&id=654b77d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654b77d9",
  null
  
)

export default component.exports